import classNames from 'classnames'
import IconChevron from 'components/partials/IconChevron'
import React, { useEffect, useRef, useState } from 'react'

const AccordionLocalContent = ({ role , children , heading, accordionId, pre_opened, modifierContainerClasses = [], modifierContentClasses = [] }) => {
  const {behaviors} = window.Drupal
  const {hash} = window.location
  const container = document.getElementById('localContent')
  const newUrl = window.location.pathname + window.location.search;
  const accordionRef = useRef(null)
  const [toggled, setToggled] = useState(pre_opened)

  useEffect(() => {
    if (hash && pre_opened) {
      accordionRef.current?.scrollIntoView( { behaviour: 'smooth' })
    }
  }, [])

  useEffect(() => {
    behaviors.dynamicImage.attach(container)
    behaviors.embedVideo.attach(container)
    if (hash) window.location.assign(hash)
  }, [toggled])
  const containerClasses = classNames(
    'accordion',
    'js-accordion',
    'rs_preserve',
    modifierContainerClasses,
  )
  const contentClasses = classNames(
    'accordion__toggle',
    'js-accordion__toggle',
    modifierContentClasses,
  )
  const contentMainClasses = classNames(
    'accordion__content',
    'js-accordion__content',
  )

  const handleClick = () => {
    setToggled(!toggled)

    if (toggled) {
      window.history.replaceState({}, "", newUrl);
    } else {
      window.location.hash = "accordion=" + accordionId
    }
  }

  return(
    <div ref={accordionRef} className={`${containerClasses} ${toggled ? "is-expanded" : ""}`} role={role ? role : undefined} data-accordion-id={accordionId ? accordionId : ''}>
        <button
          className={contentClasses}
          aria-haspopup="true"
          aria-expanded={toggled}
          onClick={handleClick}
          >
          <h3 className="heading-component u-text-base u-mr-200 u-text-left">{heading}</h3>
          <IconChevron />
        </button>
        <div className={`${contentMainClasses} ${toggled ? "u-block" : ""}`}>
          <div className="formatted-content">
            {children}
          </div>
        </div>
    </div>
  )
}

export default AccordionLocalContent
